import { call, put } from 'redux-saga/effects';
import { requestGetInboundMail, requestResolveInboundMail, requestGetInboundMailOauthStatus } from '../requests/inboundMail';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetInboundMail(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestGetInboundMail, action.payload.status);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleResolveInboundMail(action) {
    const { callback } = action.payload;
    try {
        const response = yield call(requestResolveInboundMail, action.payload.id, action.payload.body);
        if (callback) callback(response.data);
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
        if (callback) callback(null);
    }
}

export function* handleGetInboundMailOauthStatus(action) {
    const { callback } = action.payload || {};
    try {
        const response = yield call(requestGetInboundMailOauthStatus);
        if (callback) callback(response.data);
    } catch (error) {
        if (callback) callback(null);
    }
}
